import s from './Industries.module.scss';
import Image from 'next/image';
import {CircleArrowIcon} from "@/app/[locale]/common/assets/CircleArrowIcon/CircleArrowIcon";
import {TIndustriesCardProps} from "@/app/[locale]/common/components/Industries/types";
import {TextIconLink} from "@/app/[locale]/common/components/TextIconLink/TextIconLink";
import {Link} from '@/i18n/routing';
import {useTranslations} from "next-intl";

export const IndustriesCard = ({ label, text, href = '#', image }: TIndustriesCardProps) => {
    const t = useTranslations('MainPage.Industries');

    return (
        <div className={s.card}>
            <Link href={href} className={s.card_imageContainer}>
                <Image src={image} alt={label}/>
            </Link>
            <div className={s.card_container}>
                <div className={s.card_content}>
                    <label>{ label }</label>
                    <p>{ text }</p>
                </div>
                <TextIconLink
                    icon={<CircleArrowIcon />}
                    href={href}
                >
                    { t('link') }
                </TextIconLink>
            </div>
        </div>
    );
};